import type IconType from './iconType';

export default function CloseCircle({ width = 22, height = 22, color = '#667085' }: IconType) {
  return (
    <svg width={width} height={height} viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.3203 27.5C22.1953 27.5 27.8203 21.875 27.8203 15C27.8203 8.125 22.1953 2.5 15.3203 2.5C8.44531 2.5 2.82031 8.125 2.82031 15C2.82031 21.875 8.44531 27.5 15.3203 27.5Z"
        stroke={color}
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7812 18.5379L18.8562 11.4629"
        stroke={color}
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8562 18.5379L11.7812 11.4629"
        stroke={color}
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
